import * as React from 'react'
import { Form, Field, InjectedFormProps } from 'redux-form'
import { vRequired, vEmail } from 'components/Input/Input.validations'
import { Input } from 'components/Input/Input'
import { Textarea } from 'components/Input/Textarea'
import Button from 'components/Button'
import cn from 'classnames'
import * as sMarg from 'styles/modules/margins.scss'
import { Row, Col } from 'components/Layout'
import * as sLay from 'styles/modules/layout.scss'
import * as s from './ContactForm.scss'
import http from 'axios'
import config from 'src/config'
import Overlay from 'components/Overlay'
import analytics from 'features/Analytics/Analytics.utils'

const getEventByType = type => {
  switch (type) {
    case 'get-demo':
      return 'Get Demo - Button Click'

    case 'classic':
      return {
        event: 'Enquiry - Classic',
        properties: {
          category: 'Enquiry',
          label: 'Classic',
        },
      }

    case 'ultimate':
      return {
        action: 'track',
        event: 'Enquiry - Ultimate',
        properties: {
          category: 'Enquiry',
          label: 'Ultimate',
        },
      }

    case 'all-in-one':
      return {
        action: 'track',
        event: 'Enquiry - All In One',
        properties: {
          category: 'Enquiry',
          label: 'All In One',
        },
      }

    case 'lift-phone':
      return {
        action: 'track',
        event: 'Enquiry - Lift Phone',
        properties: {
          category: 'Enquiry',
          label: 'Lift Phone',
        },
      }

    case 'vms':
      return {
        action: 'track',
        event: 'Enquiry - VMS',
        properties: {
          category: 'Enquiry',
          label: 'VMS',
        },
      }
  }

  return 'Contact Form - Button Click'
}

export interface IContactFormProps extends InjectedFormProps<any> {
  type: any
}

export class ContactFormComponent extends React.Component<IContactFormProps> {
  state = {
    submitted: false,
  }

  render() {
    const { submitting, handleSubmit, type } = this.props
    const { submitted } = this.state

    const submit = (data: any) => {
      analytics.track(getEventByType(type), data)

      return http({
        method: 'POST',
        url: `${config.api.main}/api/v1/contact`,
        params: {
          type,
        },
        data: data,
      }).then(() => this.setState({ submitted: true }))
    }

    if (type === 'lift-phone') {
      return (
        <Form onSubmit={handleSubmit(submit as any)} className={s.outer}>
          <Row className={cn(sLay['layout-gt-xs-row'], sLay['layout-xs-column'], 'md')}>
            <Col className={cn(sLay['flex-gt-xs-50'], 'md')}>
              <Field name="firstName" label="First name" component={Input} validate={[vRequired]} />
            </Col>
            <Col className={cn(sLay['flex-gt-xs-50'], 'md')}>
              <Field name="lastName" label="Last name" component={Input} validate={[vRequired]} />
            </Col>
          </Row>
          <Row className={cn(sLay['layout-gt-xs-row'], sLay['layout-xs-column'], 'md')}>
            <Col className={cn(sLay['flex-gt-xs-50'], 'md')}>
              <Field
                name="email"
                label="What's your email?"
                component={Input}
                validate={[vRequired, vEmail]}
              />
            </Col>
            <Col className={cn(sLay['flex-gt-xs-50'], 'md')}>
              <Field name="phoneNumber" label="What's your Phone Number?" component={Input} />
            </Col>
          </Row>
          <Row className={cn(sLay['layout-gt-xs-row'], sLay['layout-xs-column'], 'md')}>
            <Col className={cn(sLay['flex-gt-xs-50'], 'md')}>
              <Field name="role" label="What's your role?" component={Input} />
            </Col>
            <Col className={cn(sLay['flex-gt-xs-50'], 'md')}>
              <Field name="amount" label="How many lifts are in the building?" component={Input} />
            </Col>
          </Row>
          <Row className={cn(sLay['layout-gt-xs-row'], sLay['layout-xs-column'], 'md')}>
            <Col className={cn(sLay['flex-gt-xs-50'], 'md')}>
              <Field name="street" label="Street" component={Input} />
            </Col>
            <Col className={cn(sLay['flex-gt-xs-50'], 'md')}>
              <Field name="suburb" label="Suburb" component={Input} />
            </Col>
          </Row>
          <Row className={cn(sLay['layout-gt-xs-row'], sLay['layout-xs-column'], 'md')}>
            <Col className={cn(sLay['flex-gt-xs-50'], 'md')}>
              <Field name="state" label="State" component={Input} />
            </Col>
            <Col className={cn(sLay['flex-gt-xs-50'], 'md')}></Col>
          </Row>
          <div
            className={cn(sLay['layout-column'], sLay['layout-align-center-center'], sMarg.mt30)}
          >
            <Button color="primary" size="lg" loading={submitting} type="submit">
              Enquire now!
            </Button>
          </div>

          {submitted && <Overlay>Thanks, we'll be in touch ASAP.</Overlay>}
        </Form>
      )
    }

    return (
      <Form onSubmit={handleSubmit(submit as any)} className={s.outer}>
        <Row className={cn(sLay['layout-gt-xs-row'], sLay['layout-xs-column'], 'md')}>
          <Col className={cn(sLay['flex-gt-xs-50'], 'md')}>
            <Field name="firstName" label="First name" component={Input} validate={[vRequired]} />
          </Col>
          <Col className={cn(sLay['flex-gt-xs-50'], 'md')}>
            <Field name="lastName" label="Last name" component={Input} validate={[vRequired]} />
          </Col>
        </Row>
        <Row className={cn(sLay['layout-gt-xs-row'], sLay['layout-xs-column'], 'md')}>
          <Col className={cn(sLay['flex-gt-xs-50'], 'md')}>
            <Field
              name="email"
              label="What's your email?"
              component={Input}
              validate={[vRequired, vEmail]}
            />
          </Col>
          <Col className={cn(sLay['flex-gt-xs-50'], 'md')}>
            <Field name="phoneNumber" label="What's your Phone Number?" component={Input} />
          </Col>
        </Row>
        <Row className={cn(sLay['layout-gt-xs-row'], sLay['layout-xs-column'], 'md')}>
          <Col className={cn(sLay['flex-gt-xs-50'], 'md')}>
            <Field name="company" label="What's your company?" component={Input} />
          </Col>
          <Col className={cn(sLay['flex-gt-xs-50'], 'md')}>
            <Field name="product" label="What product are you interested in?" component={Input} />
          </Col>
        </Row>
        <Field
          name="description"
          label="How can we help?"
          component={Textarea}
          validate={[vRequired]}
          display="standard"
        />
        <div className={cn(sLay['layout-column'], sLay['layout-align-center-center'], sMarg.mt30)}>
          <Button color="primary" size="lg" loading={submitting} type="submit">
            Get a demo!
          </Button>
        </div>

        {submitted && <Overlay>Thanks, we'll be in touch ASAP.</Overlay>}
      </Form>
    )
  }
}



// WEBPACK FOOTER //
// src/features/Contact/ContactForm/ContactForm.tsx